import type { AgentClientId } from '@agentwiki/shared'

export interface McpConfigSnippet {
  id: AgentClientId
  label: string
  configPath: string
  code: string
}

interface BuildSnippetOptions {
  mcpEndpoint: string
  apiKey: string
}

function remoteServerConfig(mcpEndpoint: string, apiKey: string) {
  return {
    mcpServers: {
      agentwiki: {
        type: 'http',
        url: mcpEndpoint,
        headers: { Authorization: `Bearer ${apiKey}` },
      },
    },
  }
}

export function buildMcpConfigSnippets({ mcpEndpoint, apiKey }: BuildSnippetOptions): McpConfigSnippet[] {
  const json = JSON.stringify(remoteServerConfig(mcpEndpoint, apiKey || '<YOUR_API_KEY>'), null, 2)
  return [
    {
      id: 'claude-desktop',
      label: 'Claude Desktop',
      configPath: 'Claude developer config',
      code: json,
    },
    {
      id: 'claude-code',
      label: 'Claude Code',
      configPath: '.mcp.json',
      code: json,
    },
    {
      id: 'cursor',
      label: 'Cursor',
      configPath: '.cursor/mcp.json',
      code: json,
    },
    {
      id: 'http',
      label: 'HTTP',
      configPath: 'curl',
      code: [
        `curl ${JSON.stringify(mcpEndpoint)} \\`,
        '  -H "Content-Type: application/json" \\',
        `  -H "Authorization: Bearer ${apiKey || '<YOUR_API_KEY>'}" \\`,
        '  --data \'{"jsonrpc":"2.0","id":1,"method":"tools/list","params":{}}\'',
      ].join('\n'),
    },
  ]
}
